import { useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'

const useScriptLocale = () => {
  const { lang, country } = useSelector(selectAuthData) ?? {}

  return `${lang ?? 'fr'}-${(country ?? 'fr').toUpperCase()}`
}

export default useScriptLocale
